// extracted by mini-css-extract-plugin
export default {"avatarImage":"StreamInfoSection_avatarImage__2fHq8","coverOverlay":"StreamInfoSection_coverOverlay__xXfqf"};